import { createContext, useContext } from 'react'
import type { LocationResult } from '@alexanderathoodly/data-models'

type TLocationPageContext = {
	location: LocationResult | undefined
}

export const LocationPageContext = createContext<TLocationPageContext>({
	location: undefined,
})

export const useLocationPage: () => TLocationPageContext = () =>
	useContext(LocationPageContext)
